import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { pega_historico_bolsa } from "../../services/api";

const Historico_bolsa = (props) => {
    const [data2, setData2] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio'];

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            // Mantendo os parâmetros fixos conforme o original
            const response = await pega_historico_bolsa();
            setData2(response);

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);


    const formatPercent = (value) => {
        return `${value.toFixed(2).replace('.', ',')} %`;
    };

    //     [0, 25, "white", "green"],
    // [25, 40, "white", "orange"],
    // [40, 55, "white", "red"],
    // [55, 100, "white", "darkred"],
    const getbmstyle = (value) => {
        if (value === 0) return { backgroundColor: "white", color: "white", fontSize: "13px", textAlign: "center" };
        if (value > 0 && value < 25) return { backgroundColor: "green", color: "white", fontSize: "13px", textAlign: "center" };
        if (value >= 25 && value < 40) return { backgroundColor: "orange", color: "white", fontSize: "13px", textAlign: "center" };
        if (value >= 40 && value < 55) return { backgroundColor: "red", color: "white", fontSize: "13px", textAlign: "center" };
        if (value >= 55) return { backgroundColor: "darkred", color: "white", fontSize: "13px", textAlign: "center" };
        return {};
    };

    // Estruturando os dados como objetos para facilitar o mapeamento
    let processedData = [];

    // {
    // 	"sec": "01",
    // 	"bm27": "47.02",
    // 	"bm26": "46.27",
    // 	"bm25": "44.65",
    // 	"bm24": "42.47",
    // 	"bm23": "38.79"
    // },



    if (data2 && data2.length > 0) {
        processedData = data2.map((item) => {
            const bm27 = parseFloat(item.bm27 || 0);
            const bm26 = parseFloat(item.bm26 || 0);
            const bm25 = parseFloat(item.bm25 || 0);
            const bm24 = parseFloat(item.bm24 || 0);
            const bm23 = parseFloat(item.bm23 || 0);

            return {
                unidade: unidades[parseInt(item.sec)],
                bm27,
                bm26,
                bm25,
                bm24,
                bm23

            };
        });

        // Ordenação alfabética pelas unidades
        processedData.sort((a, b) => a.unidade.localeCompare(b.unidade));
    }


    if (processedData.length > 0) {
        return (
            <div className="media">
                <h5>Historico de Bolsas Médias</h5>
                <Table striped bordered hover responsive size="sm" className="mt-3">
                    <thead>
                        <tr>
                            <th>Unidade</th>
                            <th>2027</th>
                            <th>2026</th>
                            <th>2025</th>
                            <th>2024</th>
                            <th>2023</th>
                        </tr>
                    </thead>
                    <tbody>
                        {processedData.map((row, index) => (
                            <tr key={index}>
                                <td>{row.unidade}</td>
                                <td style={getbmstyle(row.bm27)}>
                                    {formatPercent(row.bm27)}
                                </td>
                                <td style={getbmstyle(row.bm26)}>
                                    {formatPercent(row.bm26)}
                                </td>
                                <td style={getbmstyle(row.bm25)}>
                                    {formatPercent(row.bm25)}
                                </td>
                                <td style={getbmstyle(row.bm24)}>
                                    {formatPercent(row.bm24)}
                                </td>
                                <td style={getbmstyle(row.bm23)}>
                                    {formatPercent(row.bm23)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    } else {
        return (
            <div className="media">
                <h5> Historico de bolsas médias</h5>
                <p>Aguardando o banco de dados.</p>
            </div>
        );
    }
}

export default Historico_bolsa;